/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetCurrentRoleDocument = gql`
    query GetCurrentRole($companyId: Int!, $branchId: Int) {
  user(companyId: $companyId, branchId: $branchId) {
    id
    employee(companyId: $companyId) {
      id
      userBranchRelations(id: $branchId) {
        id
        role {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentRoleQuery__
 *
 * To run a query within a React component, call `useGetCurrentRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentRoleQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetCurrentRoleQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentRoleQuery, GetCurrentRoleQueryVariables> & ({ variables: GetCurrentRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>(GetCurrentRoleDocument, options);
      }
export function useGetCurrentRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>(GetCurrentRoleDocument, options);
        }
export function useGetCurrentRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>(GetCurrentRoleDocument, options);
        }
export type GetCurrentRoleQueryHookResult = ReturnType<typeof useGetCurrentRoleQuery>;
export type GetCurrentRoleLazyQueryHookResult = ReturnType<typeof useGetCurrentRoleLazyQuery>;
export type GetCurrentRoleSuspenseQueryHookResult = ReturnType<typeof useGetCurrentRoleSuspenseQuery>;
export type GetCurrentRoleQueryResult = Apollo.QueryResult<GetCurrentRoleQuery, GetCurrentRoleQueryVariables>;
export const GetOwnerRoleIdByIsOwnerDocument = gql`
    query GetOwnerRoleIdByIsOwner($branchId: Int!, $page: Int, $itemsPerPage: Int) {
  role(branchId: $branchId, page: $page, itemsPerPage: $itemsPerPage) {
    roles {
      id
      isOwner
    }
  }
}
    `;

/**
 * __useGetOwnerRoleIdByIsOwnerQuery__
 *
 * To run a query within a React component, call `useGetOwnerRoleIdByIsOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerRoleIdByIsOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerRoleIdByIsOwnerQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetOwnerRoleIdByIsOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables> & ({ variables: GetOwnerRoleIdByIsOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>(GetOwnerRoleIdByIsOwnerDocument, options);
      }
export function useGetOwnerRoleIdByIsOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>(GetOwnerRoleIdByIsOwnerDocument, options);
        }
export function useGetOwnerRoleIdByIsOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>(GetOwnerRoleIdByIsOwnerDocument, options);
        }
export type GetOwnerRoleIdByIsOwnerQueryHookResult = ReturnType<typeof useGetOwnerRoleIdByIsOwnerQuery>;
export type GetOwnerRoleIdByIsOwnerLazyQueryHookResult = ReturnType<typeof useGetOwnerRoleIdByIsOwnerLazyQuery>;
export type GetOwnerRoleIdByIsOwnerSuspenseQueryHookResult = ReturnType<typeof useGetOwnerRoleIdByIsOwnerSuspenseQuery>;
export type GetOwnerRoleIdByIsOwnerQueryResult = Apollo.QueryResult<GetOwnerRoleIdByIsOwnerQuery, GetOwnerRoleIdByIsOwnerQueryVariables>;
export const GetRoleAccessListDocument = gql`
    query GetRoleAccessList($branchId: Int!, $roleId: Int!) {
  roleAccessList(branchId: $branchId, roleId: $roleId) {
    id
    role {
      id
      name
    }
    action
    scope
  }
}
    `;

/**
 * __useGetRoleAccessListQuery__
 *
 * To run a query within a React component, call `useGetRoleAccessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleAccessListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleAccessListQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRoleAccessListQuery(baseOptions: Apollo.QueryHookOptions<GetRoleAccessListQuery, GetRoleAccessListQueryVariables> & ({ variables: GetRoleAccessListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>(GetRoleAccessListDocument, options);
      }
export function useGetRoleAccessListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>(GetRoleAccessListDocument, options);
        }
export function useGetRoleAccessListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>(GetRoleAccessListDocument, options);
        }
export type GetRoleAccessListQueryHookResult = ReturnType<typeof useGetRoleAccessListQuery>;
export type GetRoleAccessListLazyQueryHookResult = ReturnType<typeof useGetRoleAccessListLazyQuery>;
export type GetRoleAccessListSuspenseQueryHookResult = ReturnType<typeof useGetRoleAccessListSuspenseQuery>;
export type GetRoleAccessListQueryResult = Apollo.QueryResult<GetRoleAccessListQuery, GetRoleAccessListQueryVariables>;
export const CheckRolePermissionsDocument = gql`
    query CheckRolePermissions($branchId: Int!, $input: RolePermissionInput!) {
  rolePermissions(branchId: $branchId, input: $input)
}
    `;

/**
 * __useCheckRolePermissionsQuery__
 *
 * To run a query within a React component, call `useCheckRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRolePermissionsQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckRolePermissionsQuery(baseOptions: Apollo.QueryHookOptions<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables> & ({ variables: CheckRolePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>(CheckRolePermissionsDocument, options);
      }
export function useCheckRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>(CheckRolePermissionsDocument, options);
        }
export function useCheckRolePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>(CheckRolePermissionsDocument, options);
        }
export type CheckRolePermissionsQueryHookResult = ReturnType<typeof useCheckRolePermissionsQuery>;
export type CheckRolePermissionsLazyQueryHookResult = ReturnType<typeof useCheckRolePermissionsLazyQuery>;
export type CheckRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useCheckRolePermissionsSuspenseQuery>;
export type CheckRolePermissionsQueryResult = Apollo.QueryResult<CheckRolePermissionsQuery, CheckRolePermissionsQueryVariables>;
export type GetCurrentRoleQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCurrentRoleQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, employee?: { __typename?: 'EmployeeProxy', id: number, userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', id: number, role: { __typename?: 'RoleProxy', id: number } }> | null } | null } | null };

export type GetOwnerRoleIdByIsOwnerQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetOwnerRoleIdByIsOwnerQuery = { __typename?: 'Query', role: { __typename?: 'RolePaginated', roles?: Array<{ __typename?: 'RoleProxy', id: number, isOwner: boolean }> | null } };

export type GetRoleAccessListQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  roleId: Types.Scalars['Int']['input'];
}>;


export type GetRoleAccessListQuery = { __typename?: 'Query', roleAccessList: Array<{ __typename?: 'CompanyAccessProxy', id: number, action?: Types.CompanyAccess | null, scope?: Types.PermissionScope | null, role?: { __typename?: 'RoleProxy', id: number, name: string } | null }> };

export type CheckRolePermissionsQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  input: Types.RolePermissionInput;
}>;


export type CheckRolePermissionsQuery = { __typename?: 'Query', rolePermissions: boolean };
